import { useEffect } from "react";
import { subscribeTimelineEntriesSnapshot } from "../../services/timeline";
import {
  buildDashboardTimelineStateForChild,
  getIncidentEntriesForChild,
  serializeEntriesByChild,
  serializeSummaryByChild,
} from "./panelDashboardTimelineUtils";

export const usePanelDashboardTimelineFeed = ({
  activeChildOnly,
  childIdsKey,
  children,
  currentChildId,
  getUserRoleForChild,
  isMockMode,
  setAllEntries,
  setIncidents,
  setRecentEntries,
  setTimelineSummary,
}) => {
  useEffect(() => {
    if (isMockMode) {
      return;
    }

    const unsubscribes = [];
    const entriesByChild = {};
    const allEntriesByChild = {};
    const timelineSummaryByChild = {};
    const incidentsByChild = {};
    const subscribedChildren = activeChildOnly && currentChildId
      ? children.filter((child) => child.id === currentChildId)
      : children;

    subscribedChildren.forEach((child) => {
      const viewerRole = getUserRoleForChild?.(child.id) || null;
      const timelineUnsubscribe = subscribeTimelineEntriesSnapshot(child.id, (entries) => {
        const nextChildState = buildDashboardTimelineStateForChild(entries);

        allEntriesByChild[child.id] = nextChildState.allEntries;
        entriesByChild[child.id] = nextChildState.recentEntries;
        timelineSummaryByChild[child.id] = nextChildState.summary;
        incidentsByChild[child.id] = nextChildState.incidents || getIncidentEntriesForChild(entries);
        setRecentEntries((current) => {
          const next = { ...entriesByChild };
          return serializeEntriesByChild(current) === serializeEntriesByChild(next) ? current : next;
        });
        setAllEntries((current) => {
          const next = { ...allEntriesByChild };
          return serializeEntriesByChild(current) === serializeEntriesByChild(next) ? current : next;
        });
        setTimelineSummary((current) => {
          const next = { ...timelineSummaryByChild };
          return serializeSummaryByChild(current) === serializeSummaryByChild(next) ? current : next;
        });
        setIncidents((current) => {
          const next = { ...incidentsByChild };
          return serializeEntriesByChild(current) === serializeEntriesByChild(next) ? current : next;
        });
      }, { viewerRole });
      unsubscribes.push(timelineUnsubscribe);
    });

    return () => {
      unsubscribes.forEach((unsub) => {
        if (unsub) unsub();
      });
    };
  }, [
    activeChildOnly,
    childIdsKey,
    children,
    currentChildId,
    getUserRoleForChild,
    isMockMode,
    setAllEntries,
    setIncidents,
    setRecentEntries,
    setTimelineSummary,
  ]);
};
